import React from 'react';

import { useField, useFormikContext } from 'formik';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

export const FormikDatePickerField = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    return (
        <DatePicker
            {...field}
            {...props}
            selected={(field.value && new Date(field.value)) || null}
            onChange={(val) => {
                setFieldValue(field.name, val);
            }}
            dateFormat="dd/MM/yyyy"
            wrapperClassName={'tw-w-full tw-rounded-lg  tw-bg-input-background tw-text-input-text tw-font-semibold'}
        />
    );
};
